'use strict';

var _regeneratorRuntime = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\xampp83\\htdocs\\tangoamistosov2\\smartbooking\\node_modules\\@babel\\runtime/helpers/inherits");

var CryptoProvider = require('./CryptoProvider');
/**
 * `CryptoProvider which uses the SubtleCrypto interface of the Web Crypto API.
 *
 * This only supports asynchronous operations.
 */


var SubtleCryptoProvider =
/*#__PURE__*/
function (_CryptoProvider) {
  _inherits(SubtleCryptoProvider, _CryptoProvider);

  function SubtleCryptoProvider(subtleCrypto) {
    var _this;

    _classCallCheck(this, SubtleCryptoProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubtleCryptoProvider).call(this)); // If no subtle crypto is interface, default to the global namespace. This
    // is to allow custom interfaces (eg. using the Node webcrypto interface in
    // tests).

    _this.subtleCrypto = subtleCrypto || crypto.subtle;
    return _this;
  }
  /** @override */


  _createClass(SubtleCryptoProvider, [{
    key: "computeHMACSignature",
    value: function computeHMACSignature(payload, secret) {
      throw new Error('SubtleCryptoProvider cannot be used in a synchronous context.');
    }
    /** @override */

  }, {
    key: "computeHMACSignatureAsync",
    value: function () {
      var _computeHMACSignatureAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(payload, secret) {
        var encoder, key, signatureBuffer, signatureBytes, signatureHexCodes, i;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                encoder = new TextEncoder('utf-8');
                _context.next = 3;
                return this.subtleCrypto.importKey('raw', encoder.encode(secret), {
                  name: 'HMAC',
                  hash: {
                    name: 'SHA-256'
                  }
                }, false, ['sign']);

              case 3:
                key = _context.sent;
                _context.next = 6;
                return this.subtleCrypto.sign('hmac', key, encoder.encode(payload));

              case 6:
                signatureBuffer = _context.sent;
                // crypto.subtle returns the signature in base64 format. This must be
                // encoded in hex to match the CryptoProvider contract. We map each byte in
                // the buffer to its corresponding hex octet and then combine into a string.
                signatureBytes = new Uint8Array(signatureBuffer);
                signatureHexCodes = new Array(signatureBytes.length);

                for (i = 0; i < signatureBytes.length; i++) {
                  signatureHexCodes[i] = byteHexMapping[signatureBytes[i]];
                }

                return _context.abrupt("return", signatureHexCodes.join(''));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function computeHMACSignatureAsync(_x, _x2) {
        return _computeHMACSignatureAsync.apply(this, arguments);
      }

      return computeHMACSignatureAsync;
    }()
  }]);

  return SubtleCryptoProvider;
}(CryptoProvider); // Cached mapping of byte to hex representation. We do this once to avoid re-
// computing every time we need to convert the result of a signature to hex.


var byteHexMapping = new Array(256);

for (var i = 0; i < byteHexMapping.length; i++) {
  byteHexMapping[i] = i.toString(16).padStart(2, '0');
}

module.exports = SubtleCryptoProvider;